import { render, staticRenderFns } from "./prefixEdit.vue?vue&type=template&id=c43ea70a&"
import script from "./prefixEdit.vue?vue&type=script&lang=js&"
export * from "./prefixEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports